import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=5870887c"
import script from "./no-results.vue?vue&type=script&lang=js"
export * from "./no-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports